import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { PopupBaseComponent } from '../../../../../shared/components/popup/popup-base/popup-base.component';
import { AppUrls } from '../../../../../routing/app-urls';
import { PropertyConnectionSuccessPopupModel } from './property-connection-success-popup.model';
import { LayoutStore, LayoutStoreType } from '../../../../../core/store/layout.store';
import { ApplicationStore, ApplicationStoreType } from '../../../../../core/store/application.store';

@Component({
    selector: 'juyo-property-connection-success-popup',
    styleUrl: 'property-connection-success-popup.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [PopupBaseComponent],
    template: `
        <juyo-popup-base [popupId]="model().id" [showHeader]="false" [showFooter]="false">
            <div slot="body" class="success-body">
                <div class="success-icon-wrapper">
                    <span class="material-symbols-outlined success-icon">task_alt</span>
                </div>

                <div class="success-title">Property connection submitted!</div>
                <div class="success-subtitle">
                    We're setting up your PMS connection. While that syncs, you can start exploring right away.
                </div>

                <div class="tiles">
                    @if (canAccessDataDrop()) {
                        <button class="tile" type="button" (click)="onNavigate(AppUrls.dataDropUrl)">
                            <div class="tile-icon tile-icon--orange">
                                <span class="material-symbols-outlined">download</span>
                            </div>
                            <div class="tile-title">Upload Data</div>
                            <div class="tile-description">
                                Drop a spreadsheet into Data Drop for instant AI analysis, no PMS wait needed.
                            </div>
                        </button>
                    }

                    <button class="tile" type="button" (click)="onNavigate(AppUrls.hotelGptUrl)">
                        <div class="tile-icon tile-icon--purple">
                            <span class="material-symbols-outlined">chat</span>
                        </div>
                        <div class="tile-title">Ask HotelGPT</div>
                        <div class="tile-description">
                            Ask any revenue management question. HotelGPT can help even without data connected.
                        </div>
                    </button>
                </div>

                <button class="explore-link" type="button" (click)="onClose()">I'll explore on my own</button>
            </div>
        </juyo-popup-base>
    `,
})
export class PropertyConnectionSuccessPopupComponent {
    public model = input.required<PropertyConnectionSuccessPopupModel>();

    protected readonly AppUrls = AppUrls;

    private layoutStore: LayoutStoreType = inject(LayoutStore);
    private applicationStore: ApplicationStoreType = inject(ApplicationStore);
    private router = inject(Router);

    protected canAccessDataDrop = computed(() => this.applicationStore.hasDataDropAccess());

    protected onNavigate(path: string): void {
        this.layoutStore.closePopup(this.model().id);
        this.router.navigate([path]);
    }

    protected onClose(): void {
        this.layoutStore.closePopup(this.model().id);
    }
}
